import React from "react";
import { seatFitBands } from "../services/seatFit.js";
import { ViewKey } from "../v2/components/ViewKey.jsx";
export function SeatFitKey({ bufferPct }) {
  return <div data-testid="shared-seat-fit-key">
    {seatFitBands(bufferPct).map(b => <div key={b.status}>
      <strong style={{ color: b.style.ink }}>{b.label}</strong> — {b.description}
    </div>)}
  </div>;
}
export function SeatFitViewKey({ bufferPct }) {
  return <ViewKey testId="markets-seat-fit-key" title="Space fit"
    groups={[{ label: "Status", items: seatFitBands(bufferPct).map(b => ({
      label: b.label, description: b.description,
      labelStyle: { color: b.style.ink, background: b.style.bg },
      swatch: { kind: "cell", color: b.style.bg, border: b.style.border },
    })) }]}
    footer="Assigned today vs usable seats this month; forecast demand starts next month. Usable seats are installed seats adjusted for attendance. Dense is a separate sq-ft flag." />;
}
